import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { KlmrTimesheetCreateAddPage } from '../klmr-timesheet-create-add/klmr-timesheet-create-add';

@IonicPage()
@Component({
  selector: 'page-klmr-timesheet-create',
  templateUrl: 'klmr-timesheet-create.html',
})
export class KlmrTimesheetCreatePage {
  timeSheetList: any = [];
  actionAllowed:boolean = false;
  actiivityCodeList:any = [];
  totalTime:any = null;
  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider) {
  }

  ionViewDidLoad() {
    this.getPermission();
    this.getActivityCodeList();
    this.gettimeSheetList();
  }

  async getActivityCodeList() {
    this.actiivityCodeList = [];
    let formData: FormData = new FormData();
    formData.append("method_name","activity_code");
    return this.api.post("/prestart/Activity_code", false,formData)
      .then((result: any) => {
        console.log("result", result);
        if (result.status) {
          
          this.actiivityCodeList = result.result;
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      });
  }

  getCodeName(id){
    let code = "";
    let index = this.actiivityCodeList.findIndex(list_ => list_['id'] == id);
      if(index != -1){
        code = this.actiivityCodeList[index].code;
      }
    return code
  }





  gettimeSheetList() {
    this.timeSheetList = [];
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("method_name", "timesheet_list");
    // http://cotest.online/klmr_cabsand/index.php/api/prestart/timesheet/
    // /prestart/timesheet/get
    this.api.post("/prestart/timesheet/approver", true,formData)
      .then((result: any) => {
        console.log("result", result)
        this.timeSheetList = result.result;
        if(result.extra_data){
          if(result.extra_data.all_total){
            this.totalTime = result.extra_data.all_total;
          }
        }
        this.utiltiy.stopLoading();
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }


  async deleteRecord(id) {
    let status = await this.utiltiy.showDialog();
    if (status) {
      this.deleteTimeSheet(id);
    }
    console.log("status", status);
  }


 

  formatAMPM(date) {
    date = date.split(":");
    var hours = date[0];
    var minutes = date[1];
    var ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? minutes : minutes;
    // var strTime = date[0] + ':' + date[1];
    var strTime = date[0] + ':' + date[1];
    return strTime;
  }

  calculateTimeDifference(startTime, endTime) {
    if(startTime.length == 0 && endTime.length == 0){
      return "";
    }
    var start = startTime.split(":");
    var end = endTime.split(":");
    var startDate = new Date(0, 0, 0, start[0], start[1], 0);
    var endDate = new Date(0, 0, 0, end[0], end[1], 0);
    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);

    if (hours < 0)
      hours = hours + 24;
    return (hours <= 9 ? "0" : "") + hours + ":" + (minutes <= 9 ? "0" : "") + minutes;
  }


  deleteTimeSheet(id) {
    this.api.delete(`/prestart/timesheet/delete/${id}`, false)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.gettimeSheetList();
        }

      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  async acceptRecord(fuel) {
    if(!this.actionAllowed){
      return;
    }
    var options = {
      "title": '',
      "message": `Send for approval`,
      "approveText": 'Yes',
      "rejectText": 'No',
    }
    let status = await this.utiltiy.attentionDialog(options);
    if (status) {
      this.acceptTimesheet(fuel.id);
    }
    console.log("status", status);
  }

  async acceptTimesheet(id){
    let userId = await this.utiltiy.getStorage("userId");
    let formData: FormData = new FormData();
    formData.append("method_name", "approver_timesheet_reject_approve_update_status");
    // formData.append("user_id", userId);
    formData.append("timesheet_id", id);
    formData.append("status", '1');
    // timesheet/approver
    this.api.post(`/prestart/timesheet/approver`, false, formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.gettimeSheetList();
        }

      }, err => {
        console.log("err", err)
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }
  
  addTimeSheet(){
   this.navCtrl.push(KlmrTimesheetCreateAddPage, { param: null,copy:false });
 }
 updateTimeSheet(prestart){
   this.navCtrl.push(KlmrTimesheetCreateAddPage, { param: prestart,copy:false });
 }
 copyTimeSheet(prestart){
   console.log("copyTimeSheet",prestart)
   this.navCtrl.push(KlmrTimesheetCreateAddPage, { param: prestart,copy:true });
 }
 previewTimeSheet(prestart:any){
  prestart.isDisabled = true;
  this.navCtrl.push(KlmrTimesheetCreateAddPage, { param: prestart,copy:false });
}



 async getPermission(){
  this.actionAllowed =  await this.utiltiy.getPagePermission("klmr-timesheet-create-rw");
 }

}



// WEBPACK FOOTER //
// ./src/pages/klmr-timesheet-create/klmr-timesheet-create.ts